<template>
    <div id="page">
        <header class="header">
            <div class="logo" @click="showModalSetting">
                理财仓位记录
            </div>
            <div v-if="!$root.logined">
                <cv-button @click="$root.login" c="btn default small">登录</cv-button>
            </div>
            <div v-if="$root.logined">
                <span>{{$root.currentUser.username}}</span>
                <cv-button @click="logout" c="btn default small">退出登录</cv-button>
            </div>
        </header>
        <main class="main">
            <cv-table :data="mappedProducts.data" :headFixed="true" c="table custom medium" class="product">
                <template v-slot="scope">
                    <template v-if="scope.row.id != 'SUM'">
                        <cv-table-column label="#" width="3em" :scope="scope">{{scope.index+1}}</cv-table-column>
                        <cv-table-column label="操作" :width="130" :scope="scope">
                            <div>
                                <cv-button @click="showModalProduct(scope.row)" c="link primary mini underline distant-x">查看详情</cv-button>
                                <cv-button v-if="$root.hasPermission(permissions.financing.product.warning.show) || $root.hasPermission(permissions.financing.product.warning.setting)" @click="showModalWarning(scope.row, scope.index)" 
                                        :c="'link ' + (!scope.row.warningCount || scope.row.warningCount == 0 ? 'primary' : 'warn') + ' mini underline distant-x'">
                                    预警<template v-if="$root.hasPermission(permissions.financing.product.warning.show)">({{scope.row.warningCount}})</template>
                                </cv-button>
                            </div>
                        </cv-table-column>
                        <cv-table-column v-if="hasAmountPermission" label="满仓金额" width="6em" :scope="scope">{{scope.row.fullAmount / 100}}</cv-table-column>
                        <cv-table-column label="现仓位" width="7.4em" :scope="scope">{{showProduct(scope.row, scope.index)}}</cv-table-column>
                        <cv-table-column label="名称" width="10.4em" :fixed="true" :scope="scope">
                            <div :class="getNameClass(scope.row)" :title="scope.row.name">
                                {{scope.row.name}}
                            </div>
                        </cv-table-column>
                        <cv-table-column v-if="$root.logined && mode == 'ADJUST'" label="今天" width="8em" :scope="scope">
                            <cv-input v-if="!scope.head" v-model.number="positionRecords[scope.index].amount" :tabindex="scope.index+1" type="text" c="input mini" placeholder="输入金额"></cv-input>
                        </cv-table-column>
                        <cv-table-column v-for="date in mappedProducts.dates" :key="date | format" :label="date | format('M/D')" width="8em" :scope="scope">{{ showPositionRecord(scope.row, date) }}</cv-table-column>
                    </template>
                    <template v-else-if="hasAmountPermission">
                        <cv-table-column label="#" width="3em" :scope="scope">#</cv-table-column>
                        <cv-table-column label="操作" :width="130" :scope="scope">
                            <div>
                                <cv-button v-if="$root.hasPermission(permissions.financing.product.add)" @click="showModalProductAdd()" c="link default mini underline distant-x">增加产品</cv-button>
                                <cv-button v-if="$root.hasPermission(permissions.financing.product.addPositionRecord)" v-show="mode == 'SHOW'" @click="switchMode('ADJUST')" c="link primary mini underline distant-x">调仓</cv-button>
                                <cv-button v-if="$root.hasPermission(permissions.financing.product.addPositionRecord)" v-show="mode == 'ADJUST'" @click="switchMode('SHOW')" c="link default mini underline distant-x">取消</cv-button>
                            </div>
                        </cv-table-column>
                        <cv-table-column v-if="hasAmountPermission" label="满仓金额" width="6em" :scope="scope">{{scope.row.fullAmount / 100}}</cv-table-column>
                        <cv-table-column label="现仓位" width="7.4em" :scope="scope">{{showProduct(scope.row)}}</cv-table-column>
                        <cv-table-column label="名称" width="10.4em" :fixed="true" :scope="scope">{{scope.row.name}}</cv-table-column>
                        <cv-table-column v-if="$root.logined && mode == 'ADJUST'" label="今天" width="8em" :scope="scope">
                            <cv-button v-if="$root.hasPermission(permissions.financing.product.addPositionRecord)" @click="saveAdjust" c="btn warn mini">保存</cv-button>
                        </cv-table-column>
                        <cv-table-column v-for="date in mappedProducts.dates" :key="date | format" :label="date | format('M/D')" width="8em" :scope="scope">{{ showPositionRecord(scope.row, date) }}</cv-table-column>
                    </template>
                </template>
            </cv-table>
        </main>
        <modal-product ref="modalProduct"></modal-product>
        <modal-product-add ref="modalProductAdd" @add="load"></modal-product-add>
        <modal-warning ref="modalWarning" @changeWarningCount="changeWarningCount"></modal-warning>
        <modal-setting ref="modalSetting" @changeSetting="changeSetting"></modal-setting>
        <side-hop></side-hop>
    </div>
</template>

<script>
    import dayjs from "dayjs";
    
    import AnyFormat from "../../lib/any-format.js";
    import permissions from "../../js/permissions.js";
    
    import ModalProduct from "./ModalProduct.vue";
    import ModalProductAdd from "./ModalProductAdd.vue";
    import ModalWarning from "./ModalWarning.vue";
    import SideHop from "./SideHop.vue";
    import ModalSetting from "./ModalSetting";

    export default {
        name: "Page",
        components: {
            ModalSetting,
            ModalProduct,
            ModalProductAdd,
            ModalWarning,
            SideHop
        },
        data() {
            return {
                permissions: permissions,
                mode: "SHOW", // SHOW、ADJUST
                products: [],
                positionRecords: [],
                tradeDays: [],
                modals: {
                    warning: {
                        index: null
                    }
                },
                setting: {
                    show: x => x
                }
            };
        },
        computed: {
            filteredProducts() {
                let filteredProducts = this.products.filter(this.setting.show);
                return filteredProducts;
            },
            hasAmountPermission() {
                return this.$root.hasPermission(permissions.financing.product.show.amount);
            },
            hasModifyPermission() {
                return this.$root.hasPermission(permissions.financing.product.add)
                    || this.$root.hasPermission(permissions.financing.product.update)
                    || this.$root.hasPermission(permissions.financing.product.addPositionRecord);
            },
            productPositionRecordsMaps() {
                let maps = [];

                for (let i=0; i<this.filteredProducts.length; i++) {
                    let product = this.filteredProducts[i];
                    let positionRecords = product.positionRecords;
                    let map = new Map();
                    if (positionRecords) {
                        for (let j=0; j<positionRecords.length; j++) {
                            let positionRecord = positionRecords[j];
                            let positionRecordDate = positionRecord.date;
                            let positionRecordDateStr = AnyFormat.format(positionRecordDate, "YYYY-MM-DD");
                            map.set(positionRecordDateStr, positionRecord);
                        }
                    }
                    maps.push(map);
                }
                return maps;
            },
            mappedProducts() {
                let mappedProducts = [];
                let dates = []; // 有调仓记录的日期集合
                for (let i=0; i<this.filteredProducts.length; i++) {
                    let product = this.filteredProducts[i];
                    let isArchived = product.state == "ARCHIVED";
                    if (!this.hasModifyPermission && isArchived) {
                        continue;
                    }
                    mappedProducts.push({
                        id: product.id,
                        name: product.name,
                        fullAmount: product.fullAmount,
                        amount: product.amount,
                        position: product.position,
                        risk: product.risk,
                        state: product.state,
                        warningCount: product.warningCount,
                        positionRecords: this.productPositionRecordsMaps[i],
                        origin: product
                    });
                }
                let dateStrSet = new Set();
                for (let i=0; i<this.productPositionRecordsMaps.length; i++) {
                    let dateStrs = this.productPositionRecordsMaps[i].keys();
                    let dateStrObj;
                    while (!(dateStrObj = dateStrs.next()).done) {
                        dateStrSet.add(dateStrObj.value);
                    }
                }
                for (let i=0; i<this.tradeDays.length; i++) {
                    let tradeDay = this.tradeDays[i];
                    let tradeDate = tradeDay.date;
                    let tradeDateStr = AnyFormat.format(tradeDate, "YYYY-MM-DD");
                    if (dateStrSet.has(tradeDateStr)) {
                        dates.push(tradeDate);
                    }
                }
                // 有权限，增加合计行
                if (this.hasAmountPermission) {
                    
                    let sumProduct = {
                        id: "SUM",
                        name: "合计",
                        fullAmount: 0,
                        amount: 0,
                        position: "x",
                        state: "ACTIVE",
                        positionRecords: new Map()
                    };
                    for (let t=0; t<dates.length; t++) {
                        let date = dates[t];
                        let dateStr = AnyFormat.format(date, "YYYY-MM-DD");
                        sumProduct.positionRecords.set(dateStr, {
                            amount: 0,
                            position: "x"
                        });
                    }
                    for (let i=0; i<mappedProducts.length; i++) {
                        let product = mappedProducts[i];
                        sumProduct.fullAmount += product.fullAmount;
                        sumProduct.amount += product.amount;
                        for (let t=0; t<dates.length; t++) {
                            let date = dates[t];
                            let dateStr = AnyFormat.format(date, "YYYY-MM-DD");
                            let amount = product.positionRecords.get(dateStr)?.amount;
                            sumProduct.positionRecords.get(dateStr).amount += (amount || 0);
                        }
                    }
                    mappedProducts.push(sumProduct);
                }
                return {
                    dates: dates,
                    data: mappedProducts
                };
            }
        },
        async mounted() {
            await this.$root.userSemaphore.acquire();
            await this.load();
            this.$root.userSemaphore.release();
        },
        methods: {
            logout() {
                this.$root.logout();
                this.clear();
                this.load();
            },
            clear() {
                this.mode = "SHOW",
                this.products = [];
                this.positionRecords = [];
                this.tradeDays = [];
            },
            getNameClass(product) {
                if (!product?.id) {
                    return [];
                }
                return [
                    "name",
                    product.risk.toLowerCase(),
                    {
                        archived: product.state == "ARCHIVED"
                    }
                ]
            },
            async load() {
                // 加载产品
                let products = await this.$remotes.server.financing.product.list();
                let productIds = [];
                for (let i=0; i<products.length; i++) {
                    let product = products[i];
                    product.positionRecords = [];
                    if (product.state == "ACTIVE") {
                        productIds.push(product.id);
                    }
                }
                this.products = products;
                
                if (this.$root.hasPermission(permissions.financing.product.show.positionRecord)) {
                    // 加载交易日
                    this.tradeDays = await this.$remotes.server.financing.tradeDay.list();
                    
                    // 加载调仓记录
                    let positioinRecords = await this.$remotes.server.financing.positionRecord.list(productIds);
                    let positionRecordsMap = new Map();
                    for (let i=0; i<positioinRecords.length; i++) {
                        let productIdAndPositionRecords = positioinRecords[i];
                        let productId = productIdAndPositionRecords.id;
                        let positionRecords = productIdAndPositionRecords.positionRecords;
                        positionRecordsMap.set(productId, positionRecords);
                    }
                    for (let i=0; i<this.products.length; i++) {
                        let product = this.products[i];
                        let positionRecords = positionRecordsMap.get(product.id);
                        if (positionRecords) {
                            for (let i=0; i<positionRecords.length; i++) {
                                product.positionRecords.push(positionRecords[i]);
                            }
                        }
                    }
                }
            },
            showProduct(product, index) {
                if (!product) {
                    return "";
                }
                
                let amount = product.amount;
                let position = product.position;
                if (this.hasAmountPermission && index>=0 && this.mode == "ADJUST") {
                    amount += this.positionRecords[index].amount * 100;
                    position = this.$options.filters.format(amount * 100 / product.fullAmount, "0");
                }
                if (this.hasAmountPermission) {
                    return amount / 100 + " " + position + "%";
                } else {
                    return position + "%";
                }
            },
            showPositionRecord(product, date) {
                let positionRecordsMap = product.positionRecords;
                if (!positionRecordsMap) {
                    return "";
                }
                let dateStr = AnyFormat.format(date, "YYYY-MM-DD");
                let positionRecord = positionRecordsMap.get(dateStr);
                if (!positionRecord) {
                    return "";
                }
                if (this.hasAmountPermission) {
                    if (!positionRecord.amount && !positionRecord.position) {
                        return "";
                    } else {
                        return positionRecord.amount / 100 + " "
                                + positionRecord.position + "%";
                    }
                } else {
                    if (!positionRecord.position) {
                        return "";
                    } else {
                        return positionRecord.position + "%";
                    }
                }
            },
            switchMode(mode) {
                if (mode == "ADJUST") {
                    for (let i=0; i<this.mappedProducts.dates.length; i++) {
                        if (this.mappedProducts.dates[i].isSame(dayjs(), "d")) {
                            alert("今日已调仓");
                            return;
                        }
                    }
                    for (let i=0; i<this.mappedProducts.data.length-1; i++) {
                        let product = this.mappedProducts.data[i];
                        this.positionRecords.push({
                            productId: product.id,
                            date: dayjs().startOf("d"),
                            amount: null
                        });
                    }
                } else if (mode == "SHOW") {
                    this.positionRecords = [];
                }
                this.mode = mode;
            },
            showModalProductAdd() {
                this.$refs.modalProductAdd.show();
            },
            async showModalProduct(product) {
                if (!this.$root.hasPermission(permissions.financing.product.show.meta)) {
                    let acceptLogin = await this.$confirm("您需要登录才能继续访问，是否登录？").result;
                    if (acceptLogin) {
                        this.$root.login();
                    }
                    return;
                }
                this.$refs.modalProduct.show(product.origin);
            },
            async showModalWarning(product, index) {
                this.modals.warning.index = index;
                this.$refs.modalWarning.show(product);
            },
            async saveAdjust() {
                let success = await this.addPositionRecords(this.positionRecords);
                if (success) {
                    this.load();
                    this.switchMode("SHOW");
                }
            },
            async addPositionRecords(positionRecords) {
                let actualPositionRecords = [];
                for (let i=0; i<positionRecords.length; i++) {
                    if (!positionRecords[i].amount) {
                        continue;
                    }
                    actualPositionRecords.push({
                        productId: positionRecords[i].productId,
                        date: AnyFormat.format(positionRecords[i].date, "YYYY-MM-DD"),
                        amount: positionRecords[i].amount * 100
                    });
                }
                if (actualPositionRecords.length == 0) {
                    return true;
                }
                await this.$remotes.server.financing.positionRecord.add(actualPositionRecords);
                return true;
            },
            changeWarningCount(warningCount) {
                this.mappedProducts.data[this.modals.warning.index].origin.warningCount = warningCount;
            },
            showModalSetting() {
                this.$refs.modalSetting.show();
            },
            changeSetting(setting) {
                this.setting.show = this.$refs.modalSetting.$data.enums.shows[setting.show].filter;
            }
        }
    }
</script>

<style lang="scss">
    html, body, #page {
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    
    #page {
        min-width: 320px;
    }
    
    .header {
        flex-shrink: 0;
        display: flex;
        height: 50px;
        padding: 0 20px;
        justify-content: space-between;
        align-items: center;
        z-index: 50;
        background-color: white;
        border-bottom: 1px solid #deeaf0;
        
        .logo {
            font-size: 20px;
            font-weight: bold;
            cursor: pointer;
        }
        
        div>* {
            margin: 0 5px;
        }
    }
    
    .main {
        flex-grow: 1;
        width: 100%;
        overflow: auto;
    }
    
    .table {
        min-width: 100%;
        
        &.custom {
            --thead-background-color: #132b40;
            --thead-color: white;
            --tbody-odd-background-color: #fafafa;
            --tbody-odd-color: var(--color-default);
            --tbody-even-background-color: #f0f7fc;
            --tbody-even-color: var(--color-default);
        }
        
        .input {
            width: 100%;
            text-align: center;
        }
        
        .btn {
            margin: 0 5px;
        }
    }
    
    .table.product {
        .name {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            
            &::before {
                content: '* ';
            }
            &.high::before {
                color: var(--color-error)
            }
            &.middle::before {
                color: var(--color-warn)
            }
            &.low::before {
                color: var(--color-primary)
            }
            &.archived::before {
                color: var(--color-gray-7)
            }
        }
    }
</style>
